<template>
  <div class="dialog-overlay">
    <!-- 警告ダイヤログ -->
    <div class="emergency-dialog" v-show="isEmergency">
      <div class="flex justify-content-center emergency-dialog-title">
        {{ props.title }}
      </div>
      <div class="emergency-dialog-message mt-25" v-html="message"></div>
      <div class="btn btn-base-emergency ok mt-40" @click="handleYes">
        {{ props.approval }}
      </div>
      <div class="nbtn btn-base-emergency ng mt-10" @click="handleNo">
        {{ props.rejected }}
      </div>
    </div>

    <!-- 完了ダイヤログ -->
    <div class="saving-dialog" v-show="isComplete">
      <div class="flex justify-content-center saving-dialog-img"></div><!-- アイコン変更予定（要注意）-->
      <div class="flex justify-content-center saving-dialog-text">{{ $t('patk_test.saved') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isEmergency: {
      type: Boolean,
      default: false
    },
    isComplete: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      default: 'タイトル'
    },
    message: {
      type: String,
      default: 'メッセージ'
    },
    approval: {
      type: String,
      default: 'はい'
    },
    rejected: {
      type: String,
      default: 'いいえ'
    }
  },
  emits: ['response'],
  setup(props, { emit }){

    const handleYes = () => {
      if (!props.isComplete) {
        emit('response', true);
      }
    };

    const handleNo = () => {
      if (!props.isComplete) {
        emit('response', false);
      }
    };

    return {
      props,
      handleYes,
      handleNo,
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/style.scss';

</style>
